import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AgentService } from '../services/agent.service';
import { AgentHierarchySupervisorHandler } from './agent-hierarchy-supervisor.handler';
import { SettingService } from 'src/app/system-common/services/setting.service';

@Component({
  selector: 'sym-agent-hierarchy-supervisor',
  templateUrl: './agent-hierarchy-supervisor.component.html',
  styleUrls: ['./agent-hierarchy-supervisor.component.scss'],
})
export class AgentHierarchySupervisorComponent extends AgentHierarchySupervisorHandler {
  constructor(public service: AgentService, public router: Router, public settingService: SettingService) {
    super(service, router, settingService);
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
